<template>
  <div class="row flex-column gy-1 mt-0">
    <div v-if="item && (type === 'base' || item.count > 0)" class="col">
      <div class="sidebar__item row gx-1 align-items-center">
        <div v-if="item.imageUrl || item.image" class="col-auto">
          <figure
            @click="$emit('show-modal', item, type)"
            :class="{ clickable: clickable }"
            class="image"
          >
            <img
              :src="item?.images?.medium || item.imageUrl || item.image"
              :alt="decodedItemName"
            />
          </figure>
        </div>
        <div class="col d-flex flex-column overflow-x-hidden">
          <span
            @click="clickable && $emit('show-modal', item, type)"
            class="name fs-sm"
            :class="{ clickable: clickable }"
            >{{
              type === 'packaging'
                ? `Verpakking: ${decodedItemName}`
                : decodedItemName
            }}</span
          >

          <!-- Action buttons -->
          <div class="d-flex align-items-center mt-05 gap-05">
            <button
              v-if="showEditButton"
              class="btn btn--gray btn--sm"
              @click="$emit('edit')"
              aria-label="Edit item"
            >
              Wijzigen
            </button>
            <button
              v-if="showRemoveButton"
              class="remove"
              @click.stop="$emit('remove')"
              aria-label="Remove item"
            >
              <i class="icon icon-trashbin ms-0"></i>
            </button>
            <span
              v-if="item.price > 0"
              class="price mt-05 flex-grow-1 text-end"
            >
              {{ formatPrice(item.price) }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="col" v-if="emptyText.length > 0">
      <div class="empty p-3">
        <i class="icon icon-search text-primary fs-2xl"></i>
        <p class="d-block fs-sm lh-sm my-0 text-black">{{ emptyText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '../utils/priceUtils.js';
import { decodeHtml } from '../utils/utils.js';

export default {
  name: 'SidebarSingleSection',
  props: {
    clickable: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      required: true,
    },
    emptyText: {
      type: String,
      default: '',
    },
    showRemoveButton: {
      type: Boolean,
      default: true,
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['remove', 'edit', 'show-modal'],
  computed: {
    decodedItemName() {
      return decodeHtml(this.item?.name || this.item?.title || '');
    },
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price);
    },
  },
};
</script>
